import React from 'react';
import { Link } from 'react-router-dom';
import * as DATA from '../utils/Data';
import './Hero.css';

export default ({ lastFact }) => {
  if (lastFact) {
    if (lastFact.imagen) {
      return (
        <div className="hero">
          <div
            className="hero-img"
            style={{
              backgroundImage: `url(${DATA.SERVER_URL + lastFact.imagen.data.url})`
            }}
          />
          <div className="hero-data">
            <div className="hero-title">última verificación:</div>
            <div className="hero-quote">
              <span>“ </span>
              {lastFact.anuncio}
              <span> ”</span>
            </div>
            <div className="hero-context">— {lastFact.contexto}</div>
            <Link className={`btn hero-read-more scale-color--${lastFact.escala}`} to={`verificacion/${lastFact.id}`}>
              Leer informe
            </Link>
          </div>
        </div>
      );
    }
  }
  return <div className="hero">{/* <div className="hero-img" /> */}</div>;
};



// WEBPACK FOOTER //
// ./src/components/Hero.js